<template>
  <ValidationObserver ref='validationObserver'>
      <div class="new-form-row">
        <h3 class="new-form-legend">{{this.editing ? "Editando regra de relacionamento" : "Criando regra de relacionamento"}}</h3>
      </div>

      <div class="col-5">
        <crmSelect
          :options="this.static.areaOptions"
          :current="this.data.area"
          name="area"
          :onChange="areaOnChange"
          placeholder="Selecione uma área"
          />
      </div>

      <div class="col-5">
        <crmSelect
          :options="this.static.typeOptions"
          :current="this.data.type"
          name="type"
          :onChange="typeOnChange"
          placeholder="Selecione uma comunicação"
          />
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required|min:5|max:1000"
          v-slot="{ errors }">
            <div class="new-form-input">

              <input
                name="actions"
                v-model="data.actions"
                type="string"
                placeholder="Ações"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required|min:5|max:1000"
          v-slot="{ errors }">
            <div class="new-form-input">

              <input
                name="internal_description"
                v-model="data.internal_description"
                type="string"
                placeholder="Descrição interna"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required|min:5|max:1000"
          v-slot="{ errors }">
            <div class="new-form-input">

              <input
                name="public_description"
                v-model="data.public_description"
                type="string"
                placeholder="Descrição pública"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <q-dialog v-model="modal.isActive">
      <q-card style="width: 80vw; max-width: 80vw;">
        <EmailTemplateForm
          :ruleId="this.id"
          :editing="true"
          :onClose="(updatedValue) => {
            this.modal.isActive = false
          }"
        />

        <q-inner-loading :showing="modal.isLoading">
          <q-spinner-dots size="50px" color="primary"/>
        </q-inner-loading>

        <br>
        <br>

      </q-card>
    </q-dialog>

    </div>

    <div class="new-form-controls" >

      <div class="new-form-control" v-if="this.type == 'EMAIL'">
        <button
          @click="() => {
            this.modal.isActive = true
          }
          "
          class="new-form-button new-form-button-primary"
        > Editar email
        </button>
      </div>

      <div class="new-form-control">
        <button
          @click="validForm"
          class="new-form-button new-form-button-primary"
        > {{this.editing ? "Atualizar" : "Criar"}}
        </button>
      </div>
    </div>

  <div class="new-form-loading" v-if="this.isLoading"></div>
  </ValidationObserver>
</template>

<script>
import { setupAxios } from '../../setupAxios';
import { upsertRelationshipRule } from '../../apiClient';
import crmSelect from '../../components/Select';
import EmailTemplateForm from '../EmailTemplateForm/EmailTemplateForm';

export default {
  name: 'RelationshipRuleForm',
  components: { crmSelect, EmailTemplateForm },
  props: {
    editing: { type: Boolean, default: false },
    id: { type: Number },
    area: { type: String },
    area_key: { type: String },
    actions: { type: String },
    internal_description: { type: String },
    public_description: { type: String },
    type: { type: String },
    type_key: { type: String },
    onClose: { type: Function }
  },
  data: function () {
    return {
      isLoading: false,
      static: {
        areaOptions:
        [
          {
            value: 'RETENTION',
            text: 'Retenção'
          }, {
            value: 'RELATIONSHIP',
            text: 'Relacionamento'
          }, {
            value: 'NONCOMPLIANCE',
            text: 'Inadimplência'
          }
        ],
        typeOptions: [
          {
            value: 'EMAIL',
            text: 'EMAIL (com-email válido e autorização)'
          },
          {
            value: 'PHONE',
            text: 'TEL (com telefone válido e autorização)'
          },
          {
            value: 'SMS',
            text: 'SMS (com celular válido e autorização)'
          },
          {
            value: 'LETTER',
            text: 'CARTA (com endereço válido e autorização)'
          },
          {
            value: 'VISIT',
            text: 'VISITA'
          },
          {
            value: 'EVENT',
            text: 'EVENTO'
          },
        ]
      },
      data: {
        area: '',
        area_key: '',
        actions: '',
        internal_description: '',
        public_description: '',
        type: '',
        type_key: ''
      },
      modal: {
        isActive: false,
        isEditing: false,
        isLoading: false
      }
    };
  },
  async mounted () {
    this.axios = setupAxios(this.getValidationObserver());
  },
  created () {
    this.loadDataFromProps();
  },
  methods: {
    validForm: async function () {
      this.setLoading(true);
      const isValid = await (this.$refs.validationObserver.validate()) && await this.submit();
      this.setLoading(false);
      return isValid;
    },
    setLoading (isLoading) {
      this.isLoading = isLoading;
    },
    async submit () {
      return this.upsert();
    },
    async upsert () {
      const data = {
        id: this.id,
        area: this.data.area,
        actions: this.data.actions,
        internal_description: this.data.internal_description,
        public_description: this.data.public_description,
        type: this.data.type
      };
      const res = await upsertRelationshipRule(this.axios, data);
      console.log('res', res);
      if (res && res.status === 200) {
        const successText = this.editing ? 'Regra atualizada!' : 'Regra criada!';
        alert(successText);
        this.onClose(res.data.relationshipRule);
      }
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    },
    loadDataFromProps () {
      this.data.area = this.area;
      this.data.area_key = this.area_key;
      this.data.actions = this.actions;
      this.data.internal_description = this.internal_description;
      this.data.public_description = this.public_description;
      this.data.type = this.type;
      this.data.type_key = this.type_key;
    },
    areaOnChange (value, text) {
      this.data.area = value;
      this.data.area_key = text;
    },
    typeOnChange (value, text) {
      this.data.type = value;
      this.data.type_key = text;
    }
  }
};
</script>
